// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offers-landing--user-details .landing-page__wrapper{max-width:520px}`, "",{"version":3,"sources":["webpack://./offers/offers-landing/offers-landing.scss"],"names":[],"mappings":"AAMQ,qDACI,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
